import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CardAccount from "./CardAccount";
import SVG from "../../../Components/SVG";
import InfiniteScrollFooter from "../../../Components/InfiniteScrollFooter";
import { API_BASE_URL } from "../../../config/api";
import usePaginatedAccounts from "../../../hooks/usePaginatedAccounts";
import fetchWithAuthRefresh from "../../../helper/fetchWithAuthRefresh";

export default function ChooseAccount() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [cardsLoading, setCardsLoading] = useState(true);
  const {
    accounts: accountData,
    initialLoading,
    loadingMore,
    error,
    hasNext,
    sentinelRef,
    scrollRootRef,
    retry,
  } = usePaginatedAccounts({ navigate });

  useEffect(() => {
    let cancelled = false;
    const loadUser = async () => {
      try {
        const response = await fetchWithAuthRefresh(`${API_BASE_URL}auth/trader/info/`, {}, navigate);
        if (!response) return;
        if (!response.ok) throw new Error(`https error! Status: ${response.status}`);
        const data = await response.json();
        if (cancelled) return;
        setUserData(data);
        localStorage.setItem("fn", data?.fn);
        localStorage.setItem("ln", data?.ln);
      } catch (requestError) {
        console.error("Error fetching user data:", requestError);
      }
    };
    loadUser();
    return () => { cancelled = true; };
  }, [navigate]);

  useEffect(() => {
    if (!initialLoading && accountData.live.length === 0) setCardsLoading(false);
  }, [accountData.live.length, initialLoading]);

  const isLoading = initialLoading || cardsLoading;

  return (
    <div className="w-full flex-1 min-h-0 bg-zi-bg2-light dark:bg-zi-bg2-dark rounded-2xl p-5 flex flex-col gap-10 items-center justify-start relative">
      <h3 className="w-full text-start text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
        لیست حساب‌های فعال
      </h3>
      <div ref={scrollRootRef} className="w-full flex-1 min-h-0 grid lg:grid-cols-2 justify-items-center gap-x-10 gap-y-20 pb-0.5 overflow-auto">
        {accountData.live.map((item) => (
          <CardAccount key={item.id} account={item} user={userData} isLoading={isLoading} setIsLoading={setCardsLoading} />
        ))}
        {isLoading && (
          <div className="w-full px-5 flex-1 grid lg:grid-cols-2 justify-items-center gap-x-10 gap-y-20 pb-0.5 overflow-auto absolute top-[88px] left-1/2 -translate-x-1/2">
            {[0, 1].map((item) => (
              <div key={item} className={`w-full max-w-96 flex-col gap-3 ${item ? "hidden lg:flex" : "flex"}`}>
                <div className="w-full aspect-[388/246] rounded-3xl skeleton" />
                <div className="flex gap-8"><div className="w-full rounded-full h-[46px] skeleton" /><div className="w-full rounded-full h-[46px] skeleton" /></div>
              </div>
            ))}
          </div>
        )}
        {!isLoading && accountData.live.length === 0 && (
          <div className="absolute top-[116px] left-1/2 -translate-x-1/2 flex flex-col justify-center items-center gap-6 w-full">
            <p className="py-2.5 w-11/12 max-w-xs rounded-lg text-center text-lg font-light text-zi-text-light dark:text-zi-text-dark">حساب فعال ندارید</p>
            <SVG name="noAccount" classname="w-1/3 max-w-40" />
          </div>
        )}
        {!initialLoading && <InfiniteScrollFooter sentinelRef={sentinelRef} loading={loadingMore} error={error} onRetry={retry} hasNext={hasNext} />}
      </div>
    </div>
  );
}
